/*
 * File: form-time.ts
 * File Created: 2024-09-13 09:29:09
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-26 01:35:04
 * Modified By: Val Liu
 * -----
 */

import { Component } from "vue-property-decorator";
import { BaseFormComponent } from "../../core/lib/base-form-component";
import {
    IFormComponentAttr,
    IFormValidateResult,
    createRequiredValidator,
} from "../../core/lib/core";
import { PropInnateSync } from "@root/core/vue-props";
import { makeRequiredValidator } from "@root/core/decorators/make-validator";

@Component
export default class FormTime extends BaseFormComponent {
    @PropInnateSync("value", { type: Date, required: false })
    innateValue!: Date | undefined;

    /// private helpers
    // required validation for textarea
    @makeRequiredValidator({
        validator: (o) => !(o.value == null),
    })
    defaultRequired() {
        return undefined;
    }
}
